import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideModuleInfo } from '@mp/shared/util';
import { TransactionManagementPermissions } from '@mp/transaction-management/common/feature';
import {
  TransactionManagementOrganizationSettingsPermissions,
  createTransactionManagementOrganizationSettingsPlugin,
} from '@mp/transaction-management/settings/feature';
import { createClinicSupplierTransactionSettingsTabPlugin } from '@mp/transaction-management/supplier-settings/clinic-supplier-settings/feature';
import { SupplierTransactionSettingsPermissions } from '@mp/transaction-management/supplier-settings/feature';
import { createPlatformSupplierTransactionSettingsTabPlugin } from '@mp/transaction-management/supplier-settings/platform-supplier-settings/feature';
import { provideModuleOrganizationSettings, provideModulePermissions } from '@mpk/shared/data-access';
import { CLINIC_SUPPLIER_DETAILS_TAB_PLUGIN, PLATFORM_SUPPLIER_DETAILS_TAB_PLUGIN } from '@mpsm/shared/util';

const moduleName = 'TransactionManagement';

export function provideTransactionManagementFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Belegsteuerung',
    }),
    provideModulePermissions(
      moduleName,
      TransactionManagementPermissions,
      TransactionManagementOrganizationSettingsPermissions,
      SupplierTransactionSettingsPermissions,
    ),
    makeEnvironmentProviders([
      {
        provide: PLATFORM_SUPPLIER_DETAILS_TAB_PLUGIN,
        multi: true,
        useFactory: createPlatformSupplierTransactionSettingsTabPlugin,
      },
      {
        provide: CLINIC_SUPPLIER_DETAILS_TAB_PLUGIN,
        multi: true,
        useFactory: createClinicSupplierTransactionSettingsTabPlugin,
      },
    ]),
    provideModuleOrganizationSettings('Moduleinstellungen', createTransactionManagementOrganizationSettingsPlugin),
  ];
}
